import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as UsersSelectors } from 'data/users'
import { getLabel } from 'data/users/record'

import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import UserPreview from 'components/Utils/UserPreview'

const mapStateToProps = (state, { userId }) => {
  const user = UsersSelectors.getUser(state, userId)
  const hasUser = Boolean(user)
  const userLabel = hasUser ? getLabel(user) : ''
  const userPhotoURL = hasUser ? user.photoURL : ''

  return { hasUser, userLabel, userPhotoURL }
}

const mentionDecorator = WrappedComponent => ({
  hasUser,
  userLabel,
  userPhotoURL,
  ...props
}) => {
  return hasUser ? (
    <TooltipOnHover
      width={350}
      tooltipContent={
        <UserPreview userLabel={userLabel} userPhotoURL={userPhotoURL} />
      }
      placement="top"
      id={`user-preview-tooltip`}
    >
      <span>
        <WrappedComponent {...props} isClickable />
      </span>
    </TooltipOnHover>
  ) : (
    <WrappedComponent {...props} />
  )
}

export default ({ MentionPlugin }) => ({ decorator = x => x } = {}) => {
  return MentionPlugin({
    decorator: compose(
      decorator,
      connect(mapStateToProps),
      mentionDecorator
    ),
  })
}
